import {MarkupNodeType} from '#src/constants.js';
import {createHtmlTag, toBase64} from '#src/helper.js';
import {SkipType} from '#src/processing-context.js';

const convertMonospace = isMarkdown => ({options, text}) => {
  options.skipType = SkipType.SkipCode;

  return createHtmlTag(MarkupNodeType.Monospace, {'data-text': toBase64(text)}, {isMarkdown});
};

const convertNoMarkup = isMarkdown => ({options, text}) => {
  options.skipType = SkipType.SkipCode;

  return createHtmlTag(MarkupNodeType.NoMarkup, {'data-text': toBase64(text)}, {isMarkdown});
};

const convertPre = isMarkdown => ({options, text}) => {
  options.skipType = SkipType.SkipCode;

  return createHtmlTag(MarkupNodeType.Preformatted, {'data-text': toBase64(text)}, {isMarkdown});
};

export default [{
  convert: convertMonospace(true),
  escapable: true,
  op: '``',
  priority: 0
}, {
  convert: convertNoMarkup(true),
  escapable: true,
  op: "''",
  priority: 100
}, {
  cl: /\s+\\--/gu,
  convert: convertPre(true),
  escapable: true,
  op: /\/--pre\s+/gu,
  pre: true,
  priority: 200
}, {
  cl: '[/pre]',
  convert: convertPre(false),
  escapable: true,
  op: '[pre]',
  pre: true,
  priority: 700
}, {
  cl: '[/m]',
  convert: convertMonospace(false),
  escapable: true,
  op: '[m]',
  priority: 1100
}, {
  cl: '[/n]',
  convert: convertNoMarkup(false),
  escapable: true,
  op: '[n]',
  priority: 1200
}];
